import Footer from "../Components/Footer";
import Header from "../Components/Header";
import AgenticPayment from "../Components/Payment/AgenticPayment";

const AgenticPaymentPage = () => {
  return (
    <div>
      <Header />
      <AgenticPayment />
      <Footer p="5rem 9.6rem 0 9.6rem" />
    </div>
  );
};

export default AgenticPaymentPage;
